import gate from '@/api/axios';

const supportInbox = async (params = {}) => gate.get('/support/inbox', { params });

export const supportExternal = async (id) => gate.get(`/support/external/${id}`);
export const supportExternalRead = async (id) => gate.post(`/support/external/${id}/read`);
export const sendSupportExternalMessage = async (id, message) => gate.post(`/support/external/${id}/message`, { message });
export const createSupportExternalVerification = async (id) => gate.post(`/support/external/${id}/verification`);

export default supportInbox;
